import { render, staticRenderFns } from "./ModalQuestionComments.vue?vue&type=template&id=14bb692f"
import script from "./ModalQuestionComments.vue?vue&type=script&lang=js"
export * from "./ModalQuestionComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports